import React, { useEffect, useState, Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import Cookies from 'js-cookie';
import { ChevronDown } from 'react-feather';
import { useSystemCurrencies } from '../api/getCurrencies';
import { ChevronRight } from 'lucide-react';

export const SystemCurrency = () => {
  const { data, isLoading } = useSystemCurrencies({ pageNumber: 1 });
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  // Load saved or default currency
  useEffect(() => {
    if (data?.currencies?.length) {
      const savedCode = Cookies.get('system_currency');
      console.log(savedCode)
      const match =
        data.currencies.find((c) => c.currencyCode === savedCode) ||
        data.currencies.find((c) => c.currencyCode === 'UGX');
      setSelectedCurrency(match);
    }
  }, [data]);

  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
    Cookies.set('system_currency', currency.currencyCode, { expires: 365 });
  };

  const getFlagUrl = (flagCode) =>
    `https://flagcdn.com/h40/${flagCode?.toLowerCase()}.png`;

  if (isLoading || !selectedCurrency) return null;

  return (
    <Menu as="div" className="relative z-50">
      {({ open }) => (
        <>
          <Menu.Button className="flex items-center space-x-2 p-2 bg-white/10 backdrop-blur-md text-white rounded-full hover:scale-105 transition">
            <img
              src={getFlagUrl(selectedCurrency.flagCode)}
              alt={`${selectedCurrency.country} flag`}
              className="h-5 w-5 rounded-full object-cover"
            />
            <span className="font-semibold text-sm">
              {selectedCurrency.currencyCode}
            </span>
            <ChevronDown size={14} />
          </Menu.Button>

          <Transition
            as={Fragment}
            show={open}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className="absolute right-0 mt-2 w-72 rounded-2xl bg-[linear-gradient(to_bottom,_#2F6ACB,_#4455D0,_#4B3CBF)] dark:bg-[linear-gradient(to_bottom,_#0F2027,_#203A43,_#2C5364)] p-4 backdrop-blur-xl shadow-xl ring-1 ring-white/20 border border-white/10 text-white overflow-y-auto max-h-96"
            >
              <div className="">Select System Currency</div>
              <hr className="my-3 border-t border-white/10" />

              {data.currencies.map((currency) => (
                <Menu.Item key={currency.currencyCode}>
                  {({ active }) => (
                    <button
                      onClick={() => handleCurrencyChange(currency)}
                      className={`w-full text-left px-3 py-2 flex items-center space-x-3 rounded-md text-sm transition ${
                        active
                          ? 'bg-white/10 text-white'
                          : 'text-white/80 hover:bg-white/10'
                      }`}
                    >
                      <img
                        src={getFlagUrl(currency.flagCode)}
                        alt={`${currency.country} flag`}
                        className="h-5 w-5 rounded-full object-cover"
                      />
                      <div className="flex flex-row items-center space-x-2">
                        <span>{currency.country}</span>{' '}
                        <ChevronRight size={12} />{' '}
                        <span>{currency.currencyCode}</span>
                      </div>
                    </button>
                  )}
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};
